import { navigate } from '@reach/router'
import { Button, Layout, Menu } from 'antd'
import { Auth } from 'aws-amplify'
import { Link } from 'gatsby'
import * as React from 'react'
import styled from 'styled-components'

import logo from '../../images/logo.svg'
import { isAdmin, isLoggedIn, logout } from '../../utils/auth'

const { Header } = Layout

const StyledHeader = styled(Header)`
  ${({ theme, darktheme }) => {
    return `
    z-index: 5;
    background-color: ${
      darktheme ? theme['dark-background'] : theme['background']
    };
    padding: 0px;
    text-align: right;
    display: flex;
    h4,
    p,
    li, a {
      font-family: 'CustomBoldFont';
      color: ${
        darktheme === 'true' ? theme['dark-theme-color'] : theme[theme['title']]
      } !important;
    }
    li{
      font-size: 1.2em;
    }
  `
  }}
`
export const TitleContainer = styled.div`
  ${({ theme, darktheme }) => `
    background-color: ${
      darktheme ? theme['dark-background'] : theme['background']
    };
    width: 40%;
    border-bottom-color: ${theme['background']};
    border-bottom-width: 1px;
    border-bottom-style: solid;
    display: flex;
    align-items: center;
    padding-left: ${theme['padding-small']};
    border-bottom: 1px;
    border-bottom-color: rgb(232, 232, 232);
    border-bottom-style: solid;
    @media (max-width: 890px) {
      visibility: hidden;
      width: 0%;
    }

    `};
`
export const Title = styled.div`
  ${({ theme }) => `
    text-align: left;
    transform: translateY(-5%);
    h4 {
      font-size: 1.5em;
      display: inline;
      margin: ${theme['margin-zero']};
      padding: ${theme['padding-zero']} ${theme['padding-small']};
      text-transform: uppercase;
    }
    img {
      width: 30px;
    }
    p {
      line-height: 0;
      font-size: 1.15em;
      text-align: center;
      line-height: 0px;

    }
    @media(max-width: 1100px){
      p{
        font-size: 0.9em;
      }
    }
    `};
`

const StyledMenu = styled(Menu)`
  ${({ theme, darktheme }) => {
    return `
      width: 60%;
      @media (max-width: 890px){
        width: 100%;
      }
      background-color: ${
        darktheme === 'true' ? theme['dark-background'] : theme['background']
      };
      line-height: 64px;
  `
  }}
`

const SiteHeader = ({ darktheme }: { darktheme: boolean }) => (
  <StyledHeader darktheme={darktheme.toString()}>
    <TitleContainer darktheme={darktheme}>
      <Title>
        <a href="https://www.codemochi.com">
          <img src={logo} alt={'CodeMochi Logo'} />
          <h4>Code Mochi</h4>
          <p>The lost React fullstack deployment video series.</p>
        </a>
      </Title>
    </TitleContainer>
    <StyledMenu mode="horizontal" darktheme={darktheme.toString()}>
      {isAdmin() ? (
        <Menu.Item key="/admin-user-course">
          <Link to="/admin-user-course">ADMIN USERCOURSE</Link>
        </Menu.Item>
      ) : null}
      <Menu.Item key="/">
        <Link to="/">COURSES LIST</Link>
      </Menu.Item>
      {isLoggedIn() ? (
        <Menu.Item key="/mycourses">
          <Link to="/mycourses">MY COURSES</Link>
        </Menu.Item>
      ) : null}
      {isLoggedIn() ? (
        <Menu.Item
          key="/user/logout"
          onClick={() =>
            Auth.signOut()
              .then(logout(() => navigate('/user/login')))
              .catch(err => console.log('error:', err))
          }
        >
          LOGOUT
        </Menu.Item>
      ) : (
        <Menu.Item key="/user/login">
          <Link to="/user/login">LOGIN</Link>
        </Menu.Item>
      )}
      {isLoggedIn() ? null : (
        <Menu.Item key="/user/signup">
          <Link to="/user/signup">
            <Button type="primary">GET STARTED</Button>
          </Link>
        </Menu.Item>
      )}
    </StyledMenu>
  </StyledHeader>
)

export default SiteHeader
